const rgbaToRgba = (rgba, a) => {
    const parts = rgba.split(',');
    parts[3] = ` ${a})`;
    return parts.join(',');
};
const rgbToRgba = (rgb, a) => {
    return rgb.replace(')', `, ${a})`).replace('rgb', 'rgba');
};
const hexToRgba = (hex, a) => {
    const r = parseInt(hex.substring(1, 3), 16);
    const g = parseInt(hex.substring(3, 5), 16);
    const b = parseInt(hex.substring(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${a})`;
};
export const calculateColor = (color, opacity) => {
    if (color.includes('rgba')) {
        return rgbaToRgba(color, opacity);
    }
    if (color.includes('rgb')) {
        return rgbToRgba(color, opacity);
    }
    return hexToRgba(color, opacity);
};
//# sourceMappingURL=color.js.map